export enum WireComponentKind {
    Button = "page-button",
    Hint = "page-hint",
    TextField = "text-field",
    NumberField = "number-field",
    EmailField = "email-field",
    PhoneField = "phone-field",
    Hero = "hero",
    UserProfile = "user-profile",
    ContactForm = "contact-form",
    DynamicButtonBar = "dynamic-button-bar",
    List = "list",
    Container = "container",
    Fields = "fields",
    Breadcrumbs = "breadcrumbs",
    Separator = "page-separator",
}
